import { Component, OnInit } from '@angular/core';
import { Lightbox, LightboxConfig } from 'ngx-lightbox';

@Component({
  selector: 'app-work-fifteen',
  templateUrl: './work-fifteen.component.html',
  styleUrls: ['./work-fifteen.component.css']
})
export class WorkFifteenComponent implements OnInit {
  album: any = [];

  constructor(private _lightbox: Lightbox, private _lightboxConfig: LightboxConfig) { 
    // _lightboxConfig.fadeDuration = 1;
    
    this.album.push({
      'src': 'assets/img/work/captain/1.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-1.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 1
    });

    this.album.push({
      'src': 'assets/img/work/captain/2.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-2.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 2
    });

    this.album.push({
      'src': 'assets/img/work/captain/3.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-3.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 3
    });

    this.album.push({
      'src': 'assets/img/work/captain/4.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-4.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 4
    });

    this.album.push({
      'src': 'assets/img/work/captain/5.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-5.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 5
    });

    this.album.push({
      'src': 'assets/img/work/captain/6.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-6.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 6
    });

    this.album.push({
      'src': 'assets/img/work/captain/7.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-7.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 7
    });

    this.album.push({
      'src': 'assets/img/work/captain/8.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-8.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 8
    });

    this.album.push({
      'src': 'assets/img/work/captain/9.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-9.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 9
    });

    this.album.push({
      'src': 'assets/img/work/captain/10.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-10.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 10
    });

    this.album.push({
      'src': 'assets/img/work/captain/11.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/captain/thumbs/work-11.jpg',
      'type': 'image',
      'link': '/works/captain',
      'class': 'digital',
      'index': 11
    });

    this.album.push({
      'src': 'assets/img/work/captain/12.jpg',
      'caption': 'Captain Campaign Video',
      'thumb': 'assets/img/work/captain/thumbs/work-12.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/watch?v=iplN9xxWuYU',
      'class': 'digital',
      'index': 12
    });
  }

  open(index: number): void {
    this._lightbox.open(this.album, index, { wrapAround: true, showImageNumberLabel: true, disableScrolling: true, centerVertically: true });
  }

  close(): void {
    this._lightbox.close();
  }

  ngOnInit(): void {
  }
  
  openVideo(link: string): void {
    window.open(link, '_blank');
  }
}
